import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoleRoute = ({ children, allowedRoles = [] }) => {
	const { user } = useSelector((state) => state.auth);

	if (user == null) {
		return <Navigate to="/login" />;
	}
	if (allowedRoles.length === 0) {
		return <Navigate to={"/"} />;
	}
	if (allowedRoles.includes(user.role)) return children;

	return <Navigate to={"/"} />;
};
